export default {
    CONTRACTOR: "CONTRACTOR",
    CLIENT: "CLIENT",
    CLIENT_CONTRACTOR: "CLIENT_CONTRACTOR"
}